export const BACKEND_URL = 'https://yf-dev.eagleprojects.cloud'